import Button from '@mui/material/Button';

export const ButtonView = (props: any) => {
    return (
        <div>
            <Button
                type={props.type}
                classes={props.classes}
                size={props.size}
                sx={props.sx}
                variant={props.variant}
                href={props.href}
                color={props.color}
                onClick={props.onClick}
                disabled={props.disabled}
                startIcon={props.startIcon}
                endIcon={props.endIcon}
                aria-label={props.label}
            >
                {props.name}
            </Button>
        </div>
    );
}
